import React, { useState, useEffect, useRef } from 'react';
import PropTypes, { object } from 'prop-types';
import cn from 'classnames';

import { Icon, Button, WithTooltip } from '../Elements';

import classes from './ButtonWithDropdown.module.scss';

const ButtonWithDropdown = ({
  bodyButton,
  tooltipDisabled = false,
  tooltipText = 'Table Settings',
  // see options props WithTooltip component from storybook
  placement = 'top',
  icon = 'settings',
  degRotateImg = 0,
  color = '#3e88ff',
  // accepts three options: left, right, center, custom
  position = 'left',
  children = null,
  className,
  buttonClass,
  positionCustomClass,
  closeOnChange = false,
  outsideClose = false,
  show = true
}) => {
  const [windowVisible, setWindowVisible] = useState(false);

  const node = useRef();
  const buttonList = useRef();

  useEffect(() => {
    if (windowVisible) {
      document.addEventListener('mousedown', handleClick);
      document.addEventListener('keydown', escAndTabFunction);
    }
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', escAndTabFunction);
    };
  }, [windowVisible]);

  const escAndTabFunction = event => {
    if (event.code === 'Escape' || event.code === 'Tab') {
      setWindowVisible(false);
    }
  };

  const handleClick = e => {
    if (
      node.current.contains(e.target) ||
      buttonList.current.contains(e.target)
    ) {
      return;
    }
    setWindowVisible(false);
  };

  const hahdleButton = () => {
    setWindowVisible(!windowVisible);
  };

  useEffect(() => {
    setWindowVisible(false);
  }, [outsideClose]);

  if (!show) return <></>;

  return (
    <div
      ref={buttonList}
      className={cn(classes.container, className ? className : classes.wrapper)}
    >
      <WithTooltip
        text={tooltipText}
        placement={placement}
        className={cn(tooltipDisabled && classes.visually_hidden)}
      >
        <div>
          <Button
            className={cn(buttonClass ? buttonClass : classes.button)}
            onClick={hahdleButton}
            aria-label={tooltipText}
          >
            {!bodyButton ? (
              <Icon
                size="16px"
                icon={icon}
                color={color}
                style={{ transform: `rotate(${degRotateImg}deg)` }}
              />
            ) : (
              bodyButton
            )}
          </Button>
          {windowVisible && (
            <div
              className={cn(
                classes.windowWrap,
                position === 'left'
                  ? classes.windowWrap_left
                  : position === 'center'
                  ? classes.windowWrap_center
                  : position === 'custom'
                  ? positionCustomClass
                  : classes.windowWrap_right
              )}
              ref={node}
              onClick={closeOnChange ? () => setWindowVisible(false) : () => {}}
            >
              {children}
            </div>
          )}
        </div>
      </WithTooltip>
    </div>
  );
};

ButtonWithDropdown.propTypes = {
  tooltipText: PropTypes.string,
  placement: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string,
  position: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(object), PropTypes.object]),
  className: PropTypes.string,
  tooltipDisabled: PropTypes.bool,
  buttonClass: PropTypes.string,
  positionCustomClass: PropTypes.string,
  closeOnChange: PropTypes.bool,
  bodyButton: PropTypes.object,
  outsideClose: PropTypes.bool,
  degRotateImg: PropTypes.number,
  show: PropTypes.bool
};

export default ButtonWithDropdown;
